module.exports = __webpack_public_path__ + "static/img/ad5-1.7b8206c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad5-1.png
// module id = lDd9
// module chunks = 12